import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiOptionsModule } from '@fi-shared/fi-options/fi-options.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text/app-text.module';
import { Statistic2WidgetItemComponent } from '@fi-app/statistic2/statistic2-widget/statistic2-widget-item/statistic2-widget-item.component';
import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        FiOptionsModule,
        FiAppTextSharedModule,
        FiChartModule,
        FiLoadingModule,
    ],
    declarations: [Statistic2WidgetItemComponent],
    exports: [Statistic2WidgetItemComponent],
})
export class Statistic2WidgetModule {}
